export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const dummyProfile =
  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";
